import { useState } from "react";
import { reportarUsuario } from "../services/rideService";

const ELOGIOS_MOTORISTA = [
  "Ótima direção", "Muito educado", "Carro limpo",
  "Pontual", "Boa conversa", "Rota eficiente",
];

const ELOGIOS_PASSAGEIRO = [
  "Muito educado", "Pontual", "Fácil de encontrar",
  "Boa conversa", "Respeitoso", "Sem intercorrências",
];

const MOTIVOS_MOTORISTA = [
  "Comportamento inadequado", "Rota errada / desviou", "Veículo diferente do cadastro",
  "Cobrou valor errado", "Carro sujo / mal conservado", "Dirigiu de forma perigosa",
  "Assédio ou ameaça", "Outro",
];

const MOTIVOS_PASSAGEIRO = [
  "Comportamento inadequado", "Não apareceu / no-show", "Destino errado informado",
  "Pedido de rota ilegal", "Assédio ou ameaça", "Dano ao veículo", "Outro",
];

export default function RatingModal({ tipo, nome, foto, rideId, reportadoPorId, onClose, onSubmit }) {
  const [estrelas, setEstrelas] = useState(0);
  const [hoveredStar, setHoveredStar] = useState(0);
  const [elogiosSelecionados, setElogiosSelecionados] = useState([]);
  const [comentario, setComentario] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  // Denúncia
  const [showDenuncia, setShowDenuncia] = useState(false);
  const [motivoDenuncia, setMotivoDenuncia] = useState("");
  const [descDenuncia, setDescDenuncia] = useState("");
  const [enviandoDenuncia, setEnviandoDenuncia] = useState(false);
  const [denunciaEnviada, setDenunciaEnviada] = useState(false);

  const elogios = tipo === "motorista" ? ELOGIOS_MOTORISTA : ELOGIOS_PASSAGEIRO;
  const motivos = tipo === "motorista" ? MOTIVOS_MOTORISTA : MOTIVOS_PASSAGEIRO;

  const toggleElogio = (e) => {
    setElogiosSelecionados(prev =>
      prev.includes(e) ? prev.filter(x => x !== e) : [...prev, e]
    );
  };

  const labelEstrela = (n) => {
    if (n === 1) return "Muito ruim";
    if (n === 2) return "Ruim";
    if (n === 3) return "Regular";
    if (n === 4) return "Bom";
    if (n === 5) return "Excelente!";
    return "";
  };

  // Mostra seção de denúncia automaticamente se notas baixas
  const deveMostrarDenuncia = estrelas > 0 && estrelas <= 2;

  const handleSubmit = async () => {
    if (estrelas === 0) return;
    setEnviando(true);
    try {
      await onSubmit({ estrelas, elogios: elogiosSelecionados, comentario, rideId });
      setEnviado(true);
      setTimeout(() => onClose(), 1800);
    } catch (e) {
      console.error(e);
    } finally {
      setEnviando(false);
    }
  };

  const handleEnviarDenuncia = async () => {
    if (!motivoDenuncia) return;
    setEnviandoDenuncia(true);
    try {
      await reportarUsuario({
        rideId,
        reportadoPor: reportadoPorId || "anon",
        reportadoTipo: tipo,
        motivo: motivoDenuncia,
        descricao: descDenuncia,
      });
      setDenunciaEnviada(true);
    } catch (e) {
      console.error(e);
    } finally {
      setEnviandoDenuncia(false);
    }
  };

  return (
    <div style={s.overlay}>
      <style>{`
        @keyframes slideUp { from{opacity:0;transform:translateY(100%)} to{opacity:1;transform:translateY(0)} }
        @keyframes pop { 0%{transform:scale(1)} 40%{transform:scale(1.3)} 100%{transform:scale(1)} }
        @keyframes fadeIn { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
        @keyframes checkIn { from{transform:scale(0)} to{transform:scale(1)} }
        @keyframes spin { to{transform:rotate(360deg)} }
        .star-btn:hover { transform: scale(1.15); }
        .elogio-tag:active { transform: scale(0.95); }
        .rating-input:focus { outline: none; border-color: rgba(168,85,247,0.5) !important; }
        .rating-input::placeholder { color: rgba(255,255,255,0.2); }
      `}</style>

      <div style={s.sheet}>
        {/* Handle */}
        <div style={{ width: 40, height: 4, background: "rgba(255,255,255,0.12)", borderRadius: 2, margin: "0 auto 24px" }} />

        {enviado ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, padding: "16px 0 16px", animation: "fadeIn 0.4s ease" }}>
            <div style={{ width: 72, height: 72, borderRadius: "50%", background: "linear-gradient(135deg,#16a34a,#22c55e)", display: "flex", alignItems: "center", justifyContent: "center", animation: "checkIn 0.4s ease" }}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h3 style={{ color: "#fff", fontSize: 20, fontWeight: 800, margin: 0 }}>Avaliação enviada!</h3>
            <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 14, margin: 0 }}>Obrigado pelo feedback 💜</p>
            <button
              onClick={onClose}
              style={{ marginTop: 8, padding: "13px 40px", borderRadius: 50, border: "none", background: "linear-gradient(135deg,#7c3aed,#a855f7)", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}
            >
              Feito
            </button>
          </div>
        ) : showDenuncia ? (
          /* ── PAINEL DE DENÚNCIA ── */
          <div style={{ animation: "fadeIn 0.3s ease" }}>
            <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:20 }}>
              <button onClick={()=>setShowDenuncia(false)} style={{ width:32,height:32,borderRadius:"50%",border:"none",background:"rgba(255,255,255,0.07)",color:"rgba(255,255,255,0.5)",fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center" }}>←</button>
              <p style={{ color:"#fff",fontWeight:800,fontSize:16,margin:0 }}>Reportar problema</p>
            </div>

            {denunciaEnviada ? (
              <div style={{ textAlign:"center",padding:"24px 0",animation:"fadeIn 0.3s ease" }}>
                <div style={{ fontSize:48,marginBottom:12 }}>✅</div>
                <p style={{ color:"#22c55e",fontWeight:700,fontSize:15,margin:"0 0 6px" }}>Denúncia enviada!</p>
                <p style={{ color:"rgba(255,255,255,0.4)",fontSize:13,margin:0 }}>Nossa equipe analisará o ocorrido em até 48h.</p>
                <button onClick={()=>setShowDenuncia(false)} style={{ marginTop:20,padding:"12px 24px",borderRadius:50,border:"none",background:"rgba(255,255,255,0.07)",color:"rgba(255,255,255,0.5)",fontSize:13,cursor:"pointer" }}>Voltar à avaliação</button>
              </div>
            ) : (
              <>
                <p style={{ color:"rgba(255,255,255,0.4)",fontSize:12,margin:"0 0 14px" }}>Selecione o motivo:</p>
                <div style={{ display:"flex",flexWrap:"wrap",gap:8,marginBottom:16 }}>
                  {motivos.map(m => (
                    <button
                      key={m}
                      onClick={() => setMotivoDenuncia(m)}
                      style={{
                        padding:"8px 14px",borderRadius:50,fontSize:12,fontWeight:600,cursor:"pointer",transition:"all 0.2s",
                        background: motivoDenuncia===m ? "rgba(239,68,68,0.2)" : "rgba(255,255,255,0.05)",
                        border: motivoDenuncia===m ? "1px solid rgba(239,68,68,0.5)" : "1px solid rgba(255,255,255,0.1)",
                        color: motivoDenuncia===m ? "#f87171" : "rgba(255,255,255,0.5)",
                      }}
                    >{m}</button>
                  ))}
                </div>
                <textarea
                  className="rating-input"
                  placeholder="Descreva o que aconteceu (opcional)"
                  value={descDenuncia}
                  onChange={e => setDescDenuncia(e.target.value)}
                  maxLength={500}
                  rows={3}
                  style={{ width:"100%",padding:"12px 14px",borderRadius:14,background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.09)",color:"#fff",fontSize:13,resize:"none",fontFamily:"inherit",boxSizing:"border-box",marginBottom:14 }}
                />
                <button
                  onClick={handleEnviarDenuncia}
                  disabled={!motivoDenuncia || enviandoDenuncia}
                  style={{
                    width:"100%",padding:"14px",borderRadius:50,border:"none",
                    background: motivoDenuncia ? "linear-gradient(135deg,#ef4444,#dc2626)" : "rgba(255,255,255,0.07)",
                    color: motivoDenuncia ? "#fff" : "rgba(255,255,255,0.3)",
                    fontSize:14,fontWeight:700,cursor:motivoDenuncia?"pointer":"not-allowed",
                    display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                  }}
                >
                  {enviandoDenuncia ? (
                    <><span style={{ width:16,height:16,borderRadius:"50%",border:"2px solid rgba(255,255,255,0.3)",borderTopColor:"#fff",animation:"spin 0.7s linear infinite",display:"inline-block" }} /> Enviando...</>
                  ) : "⚠️ Enviar denúncia"}
                </button>
              </>
            )}
          </div>
        ) : (
          <>
            {/* ── TÍTULO ── */}
            <div style={{ textAlign: "center", marginBottom: 24 }}>
              <p style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", letterSpacing: 1.5, textTransform: "uppercase", margin: "0 0 16px" }}>
                Como foi sua corrida?
              </p>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
                <div style={{ width: 72, height: 72, borderRadius: "50%", overflow: "hidden", border: "3px solid rgba(168,85,247,0.4)", background: "linear-gradient(135deg,#7c3aed,#2563eb)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, color: "#fff", fontWeight: 700 }}>
                  {foto
                    ? <img src={foto} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    : (nome || "?").charAt(0).toUpperCase()
                  }
                </div>
                <div>
                  <p style={{ color: "#fff", fontWeight: 700, fontSize: 16, margin: 0 }}>{nome}</p>
                  <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 12, margin: "2px 0 0" }}>
                    {tipo === "motorista" ? "Seu motorista" : "Seu passageiro"}
                  </p>
                </div>
              </div>
            </div>

            {/* ── ESTRELAS ── */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, marginBottom: 24 }}>
              <div style={{ display: "flex", gap: 8 }}>
                {[1, 2, 3, 4, 5].map(n => (
                  <button
                    key={n}
                    className="star-btn"
                    onMouseEnter={() => setHoveredStar(n)}
                    onMouseLeave={() => setHoveredStar(0)}
                    onClick={() => setEstrelas(n)}
                    style={{ background: "none", border: "none", cursor: "pointer", padding: 4, transition: "transform 0.15s", animation: estrelas === n ? "pop 0.3s ease" : "none" }}
                  >
                    <svg width="40" height="40" viewBox="0 0 24 24"
                      fill={(hoveredStar || estrelas) >= n ? "#f59e0b" : "rgba(255,255,255,0.1)"}
                      stroke={(hoveredStar || estrelas) >= n ? "#f59e0b" : "rgba(255,255,255,0.2)"}
                      strokeWidth="1.5"
                      style={{ transition: "fill 0.15s, stroke 0.15s" }}
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  </button>
                ))}
              </div>
              {(hoveredStar || estrelas) > 0 && (
                <p style={{ color: "#f59e0b", fontSize: 14, fontWeight: 600, margin: 0, animation: "fadeIn 0.2s ease" }}>
                  {labelEstrela(hoveredStar || estrelas)}
                </p>
              )}
            </div>

            {/* ── ELOGIOS (só aparece se ≥ 4 estrelas) ── */}
            {estrelas >= 4 && (
              <div style={{ marginBottom: 20, animation: "fadeIn 0.3s ease" }}>
                <p style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", margin: "0 0 12px", letterSpacing: 0.5 }}>
                  O que você mais gostou?
                </p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {elogios.map(e => (
                    <button
                      key={e}
                      className="elogio-tag"
                      onClick={() => toggleElogio(e)}
                      style={{
                        padding: "8px 14px", borderRadius: 50, fontSize: 13, fontWeight: 600,
                        cursor: "pointer", transition: "all 0.2s",
                        background: elogiosSelecionados.includes(e)
                          ? "linear-gradient(135deg,#7c3aed,#a855f7)"
                          : "rgba(255,255,255,0.06)",
                        border: elogiosSelecionados.includes(e)
                          ? "1px solid rgba(168,85,247,0.5)"
                          : "1px solid rgba(255,255,255,0.1)",
                        color: elogiosSelecionados.includes(e) ? "#fff" : "rgba(255,255,255,0.55)",
                        boxShadow: elogiosSelecionados.includes(e)
                          ? "0 4px 14px rgba(124,58,237,0.3)"
                          : "none",
                      }}
                    >
                      {e}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* ── COMENTÁRIO ── */}
            {estrelas > 0 && (
              <div style={{ marginBottom: 20, animation: "fadeIn 0.3s ease" }}>
                <textarea
                  className="rating-input"
                  placeholder={estrelas >= 4 ? "Algum comentário adicional? (opcional)" : "O que poderia ter sido melhor?"}
                  value={comentario}
                  onChange={e => setComentario(e.target.value)}
                  maxLength={300}
                  rows={3}
                  style={{
                    width: "100%", padding: "12px 14px", borderRadius: 14,
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.09)",
                    color: "#fff", fontSize: 14, resize: "none",
                    fontFamily: "inherit", boxSizing: "border-box",
                  }}
                />
                <p style={{ fontSize: 11, color: "rgba(255,255,255,0.2)", margin: "4px 0 0", textAlign: "right" }}>
                  {comentario.length}/300
                </p>
              </div>
            )}

            {/* ── DENÚNCIA (nota baixa ≤ 2) ── */}
            {deveMostrarDenuncia && !denunciaEnviada && (
              <div style={{ marginBottom:16,padding:"12px 14px",background:"rgba(239,68,68,0.07)",borderRadius:14,border:"1px solid rgba(239,68,68,0.2)",animation:"fadeIn 0.3s ease" }}>
                <p style={{ color:"#f87171",fontWeight:700,fontSize:13,margin:"0 0 6px" }}>⚠️ Algo deu errado?</p>
                <p style={{ color:"rgba(255,255,255,0.4)",fontSize:12,margin:"0 0 10px" }}>Se houve problema sério, você pode reportar para nossa equipe.</p>
                <button onClick={()=>setShowDenuncia(true)} style={{ width:"100%",padding:"10px",borderRadius:10,border:"1px solid rgba(239,68,68,0.3)",background:"rgba(239,68,68,0.12)",color:"#f87171",fontSize:13,fontWeight:700,cursor:"pointer" }}>
                  Reportar problema
                </button>
              </div>
            )}

            {denunciaEnviada && (
              <div style={{ marginBottom:16,padding:"10px 14px",background:"rgba(34,197,94,0.07)",borderRadius:12,border:"1px solid rgba(34,197,94,0.2)",animation:"fadeIn 0.3s ease" }}>
                <p style={{ color:"#22c55e",fontSize:12,fontWeight:600,margin:0 }}>✓ Denúncia registrada — obrigado!</p>
              </div>
            )}

            {/* ── BOTÕES ── */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <button
                onClick={handleSubmit}
                disabled={estrelas === 0 || enviando}
                style={{
                  width: "100%", padding: "15px", borderRadius: 50, border: "none",
                  background: estrelas > 0
                    ? "linear-gradient(135deg,#7c3aed 0%,#a855f7 50%,#ec4899 100%)"
                    : "rgba(255,255,255,0.07)",
                  color: estrelas > 0 ? "#fff" : "rgba(255,255,255,0.3)",
                  fontSize: 15, fontWeight: 700,
                  cursor: estrelas === 0 || enviando ? "not-allowed" : "pointer",
                  boxShadow: estrelas > 0 ? "0 8px 24px rgba(124,58,237,0.35)" : "none",
                  transition: "all 0.3s",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                }}
              >
                {enviando ? (
                  <>
                    <span style={{ width: 18, height: 18, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
                    Enviando...
                  </>
                ) : "Enviar avaliação"}
              </button>
              <button
                onClick={onClose}
                style={{ width: "100%", padding: "12px", borderRadius: 50, border: "none", background: "transparent", color: "rgba(255,255,255,0.25)", fontSize: 13, cursor: "pointer" }}
              >
                Pular por agora
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: "fixed", inset: 0, zIndex: 99999,
    background: "rgba(0,0,0,0.7)", backdropFilter: "blur(6px)",
    display: "flex", alignItems: "flex-end",
  },
  sheet: {
    width: "100%", maxWidth: 480, margin: "0 auto",
    background: "linear-gradient(160deg,#0d0f2b 0%,#0a0e1a 100%)",
    borderRadius: "28px 28px 0 0",
    padding: "20px 20px 40px",
    border: "1px solid rgba(255,255,255,0.07)",
    borderBottom: "none",
    animation: "slideUp 0.35s ease",
    maxHeight: "90vh",
    overflowY: "auto",
  },
};
